<template>
  <li v-if="soy" class="context__menu-item">
    <nuxt-link :to="{ name: 'supervision-mg' }" class="context__menu-item-link">
      <i class="context__menu-item-icon iconoir-eye-empty"></i>
      Supervisión
    </nuxt-link>
  </li>
</template>

<script>
import { cargar, supervision } from '@extras_mg/supervision'

/**
 * "Supervisión" en el menu de usuario. Solo existe para Victor e Isaac: lo
 * decide el servidor (/supervision/yo/), y la pagina vuelve a preguntar.
 */
export default {
  name: 'MenuSupervision',
  computed: {
    soy() {
      return supervision.soy
    },
  },
  mounted() {
    cargar(this.$client, this.$store.getters['auth/getUserId'])
  },
}
</script>
